import React from "react";
import moment from "moment";
import {Col, Row} from "react-bootstrap";

import "react-table/react-table.css";

import BizLocationSelector from "../../component/BizLocation/BizLocationSelector";
import ApplicationUserSelector from "../../user/application/component/ApplicationUserSelector";
import ReadpointSelector from "../../readpoint/component/ReadpointSelector";
import TransactionStatusSelector from "./TransactionStatusSelector";
import {DateRangeSelector} from "../../component/Date/DateRangeSelector";
import MovementOrderSelector from "../../movementOrder/component/MovementOrderSelector";
import CheckpointSelector from "../../checkpoint/CheckpointSelector";

class TransactionGridFilter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      defaultDate: props.defaultDate,
      onChange: props.onChange
    };
  }

  render() {
    const {onChange} = this.state;

    const handleSetValue = (filterEntity) => {
      return (value) => {
        if (Array.isArray(value)) {
          this.state[filterEntity] = value.map(x => x.id).join(',')
        } else {
          this.state[filterEntity] = value
        }

        onChange && onChange(this.state)
      }
    }

    return (
      <div>
        <Row>
          <Col sm={4}>
            <BizLocationSelector
              multiple
              setValue={
                handleSetValue('bizLocation')
              }
            />
          </Col>
          <Col sm={4}>
            <TransactionStatusSelector
              multiple
              onChange={
                handleSetValue('transactionStatus')
              }/>
          </Col>
          <Col sm={4}>
            <ReadpointSelector
              multiple
              onChange={
                handleSetValue('readpoint')
              }/>
          </Col>
          <Col sm={4}>
            <CheckpointSelector
              multiple
              onChange={
                handleSetValue('checkpoint')
              }/>
          </Col>
          <Col sm={4}>
            <ApplicationUserSelector
              title="Usuário"
              multiple
              onChange={
                handleSetValue('user')
              }/>
          </Col>
          <Col sm={4}>
            <DateRangeSelector
              onChange={(startDate, endDate) => {
                this.setState({startDate, endDate})
                onChange({...this.state, startDate, endDate})
              }}
              defaultStartDate={moment().subtract(1, 'days')}
            />
          </Col>
          <Col sm={4}>
            <MovementOrderSelector
              multiple
              onChange={
                handleSetValue('movementOrder')
              }
            />
          </Col>
        </Row>
      </div>
    );
  }

}

export default TransactionGridFilter;



// WEBPACK FOOTER //
// ./src/transaction/component/TransactionGridFilter.js